import type { IconProps } from "@/lib/icons";
import { IconLoadingCircle } from "@/lib/icons";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

function Spinner({ className, ...props }: IconProps) {
  const { t } = useTranslation("common");
  return (
    <IconLoadingCircle
      role="status"
      aria-hidden={false}
      aria-label={t("LOADING")}
      className={cn("size-4 animate-spin", className)}
      {...props}
    />
  );
}

export { Spinner };
